// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Q0sS","name":"ConsentHeader_name__puvbH","birthday":"ConsentHeader_birthday__1OrzB","skeleton":"ConsentHeader_skeleton__1Mc-P"};